import styles from './AuthTitle.css'

class AuthTitle extends React.PureComponent {
  render () {
    return (
      <div className={styles.title}>{this.props.title}</div>
    )
  }
}

AuthTitle.propTypes = {
  title: React.PropTypes.string
}

export default AuthTitle



// WEBPACK FOOTER //
// ./app/components/Titles/AuthTitle.js